import axios from 'axios';
import config from '../config';
import { store } from '../store';

const getHeaders = () => {
  const { authToken } = store.getState().user;
  return { authorization: authToken };
};

const base = () => `${config.apiBaseUrl}/max-users/agents`;

export const getRoster = (agentType = 'doctor') =>
  axios
    .get(`${base()}/roster`, {
      params:  { agent_type: agentType },
      headers: getHeaders(),
    })
    .then((r) => r.data);

export const promoteToTc = (agentId, reason) =>
  axios
    .post(
      `${base()}/${agentId}/promote-to-tc`,
      { reason },
      { headers: getHeaders() }
    )
    .then((r) => r.data);

export const getAudit = (agentId, limit = 20) =>
  axios
    .get(`${base()}/${agentId}/audit`, {
      params:  { limit },
      headers: getHeaders(),
    })
    .then((r) => r.data);
